import { z } from 'zod';
import { DocumentSchema, DocumentLineSchema, SdiStatusSchema } from '../domain/document.js';

export const FiscalProviderKindSchema = z.enum(['acube', 'aruba_develop']);
export type FiscalProviderKind = z.infer<typeof FiscalProviderKindSchema>;

export const DocumentRefSchema = z.object({
  provider_doc_id: z.string(),
  provider: FiscalProviderKindSchema,
  sdi_id: z.string(),
  received_at: z.string().datetime(),
});
export type DocumentRef = z.infer<typeof DocumentRefSchema>;

export const ParsedInvoiceSchema = z.object({
  document: DocumentSchema.omit({ id: true, created_at: true }),
  lines: z.array(DocumentLineSchema.omit({ doc_id: true })),
});
export type ParsedInvoice = z.infer<typeof ParsedInvoiceSchema>;

export interface FiscalProvider {
  readonly kind: FiscalProviderKind;
  onboardTenant(input: {
    piva: string;
    cf?: string;
    delegaFileId?: string;
  }): Promise<{ providerAccountId: string; status: string }>;
  registerWebhook(
    providerAccountId: string,
    callbackUrl: string,
  ): Promise<{ webhookSecret: string }>;
  listIncoming(providerAccountId: string, since: Date): Promise<DocumentRef[]>;
  fetchXml(providerAccountId: string, providerDocId: string): Promise<string>;
  getStatus(providerAccountId: string, sdiId: string): Promise<z.infer<typeof SdiStatusSchema>>;
}
